import {Link} from '@material-ui/core';
import PropTypes from 'prop-types';
import {pathOr} from 'ramda';
import React from 'react';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {Bold} from '../atoms/Text';
import InfoList from '../molecules/InfoList';
import AlarmCode from './AlarmCode';
import {getLocalTime, hasBypass, hasCriticalAlarmOrBypass} from '../utils/systems';

const listItem = (...path) => pathOr('-', path);

const project = listItem('project', 'code');
const vessel = listItem('project', 'vessel');
const owner = listItem('project', 'owner', 'name');
const status = listItem('status');

const VesselInfo = ({system, history, ...props}) => (
  <Container {...props}>
    <Header>{system.id}</Header>
    <InfoList items={{
      'Project': project(system),
      'Vessel': vessel(system),
      'Project owner': owner(system),
      'Status': status(system),
      'Local time': getLocalTime(system),
      'Critical Alarms': hasCriticalAlarmOrBypass(system)
        ? <AlarmCode alarmCategory={system.alarmCategory} hasBypass={hasBypass(system)}/>
        : '-',
    }}/>
    <DetailsLink onClick={() => history.push(`/system/${system.id}`)}>
      Go to system details page
    </DetailsLink>
  </Container>
);

VesselInfo.propTypes = {
  system: PropTypes.object,
  history: PropTypes.object,
};

export default withRouter(VesselInfo);

const Container = styled.div`
  font-size: 15px;
  line-height: 25px;
`;

const Header = styled(Bold)`
  font-size: inherit;
  line-height: inherit;
`;

const DetailsLink = styled(Link)`
  display: inline-block;
  cursor: pointer;
  margin-top: 20px;
`;
